import { render, staticRenderFns } from "./PO-Serial-Number-Dialog.vue?vue&type=template&id=58445764"
import script from "./PO-Serial-Number-Dialog.vue?vue&type=script&lang=js"
export * from "./PO-Serial-Number-Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports